import styles from './styles.module.scss';

const TicketCommentNotification = () => {
  return <div className={styles.commentNotification} />;
};

export default TicketCommentNotification;
